export const C = (maxValue: number, divide: number) => Math.floor(maxValue / divide)
export const sum = (a: number, b: number) => Number((a + b).toFixed(2))
export const colorGenerator = (count: number) => {
    const colors = [
        "#FFFE00",
        "#00FFEE",
        "#B100FF",
        "#FFA500",
        "#7DFF00",
        "#3600FF",
        "#007EFF",
        "#FF6100",
        "#FF0000",
        "#FF00E4",
        "#FF0078",
        "#9B00FF",
        "#1400FF"
    ]
    for (let i = 0; i <= colors.length; i++) {
        return colors.slice(0, count)
    }
}

const date = new Date()
export const calculateWeekDay = () => {
    switch (date.getDay()) {
        case 1:
            return -1
        case 2:
            return -2
        case 3:
            return -3
        case 4:
            return -4
        case 5:
            return -5
        case 6:
            return -6
        case 0:
            return -7
    }
}
